// Operator vocabulary shared by the threshold sliders (ACT2-534).

/** A highlighted span on the axis, in percent of the track. */
export type Span = [number, number];

export const RANGE_OPS = new Set(['btw', 'nbtw']);
/** The operators that cut the domain at the handle, so a span is a faithful picture of what matches. */
export const CONTINUOUS_OPS = new Set(['gt', 'gte', 'lt', 'lte', 'btw', 'nbtw']);
/** Single-value operators. A binned/quantile chart cannot resolve these — see `bucketBound`. */
export const POINT_OPS = new Set(['eq', 'neq']);

/**
 * Highlighted span(s) for a CONTINUOUS operator, in axis percent — one region, computed once, so the
 * shaded plot and the quoted count can never drift apart.
 *
 * `eq`/`neq` deliberately return nothing: their matching set is a single value, which no span over
 * binned data describes honestly. Callers render those through the bucket-bound path instead.
 */
export function continuousSegments(
  op: string,
  pos: { single: number; lo: number; hi: number },
  pct: (v: number) => number,
): Span[] {
  switch (op) {
    case 'gt':
    case 'gte':
      return [[pct(pos.single), 100]];
    case 'lt':
    case 'lte':
      return [[0, pct(pos.single)]];
    case 'btw':
      return [[pct(pos.lo), pct(pos.hi)]];
    case 'nbtw':
      return [
        [0, pct(pos.lo)],
        [pct(pos.hi), 100],
      ];
    default:
      return [];
  }
}
